import { render, staticRenderFns } from "./ValidationFiduciaList.vue?vue&type=template&id=43087851&"
import script from "./ValidationFiduciaList.vue?vue&type=script&lang=js&"
export * from "./ValidationFiduciaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports